export const boardChannelTour = {
  key: "boardChannel",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-channel-newpost"]',
      content: t("Tour_BoardChannel_NewPost"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-channel-posts"]',
      content: t("Tour_BoardChannel_Posts"),
      placement: "top",
    },
    {
      target: '[data-tour="board-channel-topics"]',
      content: t("Tour_BoardChannel_Topics"),
      placement: "right",
    },
  ],
};
